import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';
import { Label } from '@mlb/react-patterns/components/Button/button.style.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

const DeleteReelButton = styled(ButtonPattern).attrs(({
    label, onClick, ...otherProps
}) => ({
    iconName: 'trash',
    label: label,
    handlers: {
        onClick: onClick,
    },
    ...otherProps,
}))`
    ${Label} {
        vertical-align: middle;
    }
    ${IconWrapper} {
        padding-top: 0;
        vertical-align: middle;
        stroke: none;
    }
`;

DeleteReelButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default DeleteReelButton;
